import { gql } from '@apollo/client';

export const PROPERTY_PRICE_FRAGMENT = gql`
  fragment PropertyPrice on Property {
    price {
      info {
        price
        priceTo
        commonShareDebt
        commonShareDebtTo
        commonCosts
        commonCostsTo
      }
    }
  }
`;
